import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { FULL_API_BASE_URL } from "../../Config/Config";

export const fetchClassTypeData = createAsyncThunk(
  "api/classtype",
  async () => {
    const response = await fetch(`${FULL_API_BASE_URL}/get-classes`);
    const data = await response.json();
    return data;
  }
);

const courseSlice = createSlice({
  name: "classType",
  initialState: {
    classtypedata: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchClassTypeData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchClassTypeData.fulfilled, (state, action) => {
        state.loading = false;
        state.classtypedata = action.payload;
      })
      .addCase(fetchClassTypeData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default courseSlice.reducer;
